import { Box, ButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { StyledButton } from '../Communication/Communication.styles'
import { Outlet, useNavigate, useParams, useLocation } from 'react-router-dom'

const PreboardingConfiguration = () => {
  const { tenant } = useParams<{ tenant: string }>();
  const navigate = useNavigate();
  const location = useLocation(); // ✅ Needed to track current route

  const [selectedOption, setSelectedOption] = useState<"offer-letter" | "candidate-details" | "documents" | "hiring-experience">("offer-letter");

  // ✅ Handle tab switch and route change
  const handleTabClick = (option: "offer-letter" | "candidate-details" | "documents" | "hiring-experience") => {
    setSelectedOption(option);
    navigate(`/${tenant}/preboarding-configuration/${option}`);
  };

  useEffect(() => {
  const path = location.pathname.split("/").pop();

  if (location.pathname === `/${tenant}/preboarding-configuration`) {
    navigate(`/${tenant}/preboarding-configuration/offer-letter`, { replace: true });
    setSelectedOption("offer-letter");
  } else if (path && ['offer-letter', 'candidate-details', 'documents',"hiring-experience"].includes(path)) {
    setSelectedOption(path as typeof selectedOption);
  }
}, [location.pathname, navigate, tenant]);


  return (
    <Box sx={{ marginLeft: '2.3vw', marginRight: '1.3vw' }}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" gap={5} alignItems="center" sx={{ mb: 1.2 }}>
        <Typography gutterBottom variant="h5">Preboarding Configuration</Typography>
      </Box>

      {/* Tabs */}
      <Box display="flex" justifyContent="space-between" sx={{ maxWidth: '40vw' }}>
        <ButtonGroup variant="outlined" sx={{ width: '100%' }}>
          <StyledButton
            variant="outlined"
            sx={{ mr: 0.13, flexGrow: 1,fontWeight: 500 }}
            isselected={selectedOption === 'offer-letter'}
            onClick={() => handleTabClick('offer-letter')}
          >
            Offer Setup
          </StyledButton>

          <StyledButton
            variant="outlined"
            sx={{ flexGrow: 1 ,fontWeight: 500 }}
            isselected={selectedOption === 'candidate-details'}
            onClick={() => handleTabClick('candidate-details')}
          >
            Candidate Details
          </StyledButton>

          <StyledButton
            variant="outlined"
            sx={{ flexGrow: 1,fontWeight: 500  }}
            isselected={selectedOption === 'documents'}
            onClick={() => handleTabClick('documents')}
          >
            Documents
          </StyledButton>

          <StyledButton
            variant="outlined"
            sx={{ flexGrow: 1,fontWeight: 500  }}
            isselected={selectedOption === 'hiring-experience'}
            onClick={() => handleTabClick('hiring-experience')}
          >
            Hiring Experience
          </StyledButton>
        </ButtonGroup>
      </Box>

      {/* Content */}
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: '100%', mb: '1.6vw' }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default PreboardingConfiguration
